import { render, staticRenderFns } from "./GameButton.vue?vue&type=template&id=7287b970&"
import script from "./GameButton.vue?vue&type=script&lang=js&"
export * from "./GameButton.vue?vue&type=script&lang=js&"
import style0 from "./GameButton.vue?vue&type=style&index=0&id=7287b970&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports